import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import ArticlePage from "@/pages/article/page";
import { articlesByLang, defaultLang } from "@/lib/articles";

const articleSlugToLang = new Map<string, string>();
Object.entries(articlesByLang).forEach(([lang, list]) => {
  list.forEach((a) => articleSlugToLang.set(a.slug, lang));
});

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to={`/${defaultLang}`} replace />,
  },
  {
    path: `/:lang`,
    element: <Home />,
  },
  {
    path: `/:lang/:slug`,
    element: <ArticlePage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;

export { articleSlugToLang };